import { memo } from 'react'
import { Markdown } from '@highlight/ui'

interface ArtifactProps {
  content: string
  footer?: React.ReactNode
}

export const Artifact = memo(({ content, footer }: ArtifactProps) => {
  return (
    <div className="flex flex-col gap-3 rounded-xl p-4 shadow-sm">
      <Markdown size="sm">{content}</Markdown>
      {footer && <div className="mt-auto flex items-end justify-between gap-4">{footer}</div>}
    </div>
  )
})

Artifact.displayName = 'Artifact'
